module.exports = __webpack_public_path__ + "static/media/bespoke-main.dacf3266.svg";